import React from 'react';
import { motion } from 'framer-motion';
import EmojiGif from './EmojiGif';

interface RestaurantCountDisplayProps {
  chargerName: string;
  restaurantCount: number;
  onUpgradePrompt: () => void;
  t: (key: string) => string;
}

export const RestaurantCountDisplay: React.FC<RestaurantCountDisplayProps> = ({
  chargerName,
  restaurantCount,
  onUpgradePrompt,
  t
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow-lg border-2 border-orange-200 p-6 text-center max-w-sm mx-auto"
    >
      {/* Restaurant Count */}
      <div className="mb-4">
        <div className="flex items-center justify-center mb-2">
          <EmojiGif emoji="🍽️" size="lg" className="mr-3" />
          <span className="text-3xl font-bold text-orange-600">
            {restaurantCount}
          </span>
        </div>
        <p className="text-sm text-gray-600">
          {restaurantCount === 1 ? t('restCount_foundSingular') : t('restCount_foundPlural')} {t('restCount_near')}
        </p>
        <p className="font-medium text-gray-800 truncate">
          {chargerName}
        </p>
      </div>

      {/* Upgrade Prompt */}
      <div className="border-t border-gray-200 pt-4">
        <p className="text-sm text-gray-600 mb-3">
          {t('restCount_signupPrompt')}
        </p>
        
        <button
          onClick={onUpgradePrompt}
          className="w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
        >
          <span className="flex items-center justify-center">
            <EmojiGif emoji="⭐" size="sm" className="mr-2" />
            {t('restCount_unlockFullDetails')}
          </span>
        </button>

        <p className="text-xs text-gray-500 mt-2">
          {t('restCount_freeToSignup')}
        </p>
      </div>

      {/* Feature Teaser */}
      <div className="mt-4 p-3 bg-gray-50 rounded-lg">
        <p className="text-xs font-medium text-gray-700 mb-2">
          {t('restCount_plusFeaturesInclude')}
        </p>
        <ul className="text-xs text-gray-600 space-y-1">
          <li className="flex items-center">
            <EmojiGif emoji="⭐" size="xs" className="mr-1" />
            {t('restCount_featureRatings')}
          </li>
          <li className="flex items-center">
            <EmojiGif emoji="💰" size="xs" className="mr-1" />
            {t('restCount_featurePrices')}
          </li>
          <li className="flex items-center">
            <EmojiGif emoji="🚗" size="xs" className="mr-1" />
            {t('restCount_featureNavigation')}
          </li>
        </ul>
      </div>
    </motion.div>
  );
};

export default RestaurantCountDisplay;